import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";
import "./FinancialResults.style.css";

const FinancialResults = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  const results = {
    2025: {
      Q2: [
        {
          name: { tr: "Yatırımcı Sunumu (2Ç 2025)", en: "Investor Presentation (Q2 2025)" },
          href: { tr: "/static/docs/financials/2025/q2/investor-presentation-tr.pdf", en: "/static/docs/financials/2025/q2/investor-presentation-en.pdf" },
        },
        // {
        //   name: { tr: "Kazanç Açıklaması", en: "Earnings Release" },
        //   href: { tr: "/static/docs/financials/2025/q2/earnings-release-tr.pdf", en: "/static/docs/financials/2025/q2/earnings-release-en.pdf" },
        // },
        {
          name: { tr: "Finansal Tablolar", en: "Financial Statements" },
          href: { tr: "/static/docs/financials/2025/q2/financial-statements-tr.pdf", en: "/static/docs/financials/2025/q2/financial-statements-en.pdf" },
        },
      ],
    },
    // 2024: {
    //   Q4: [
    //     {
    //       name: { tr: "Yatırımcı Sunumu (Q4 2024)", en: "Investor Presentation (Q4 2024)" },
    //       href: { tr: "/static/docs/financials/2024/q4/investor-presentation-tr.pdf", en: "/static/docs/financials/2024/q4/investor-presentation-en.pdf" },
    //     },
    //     {
    //       name: { tr: "Kazanç Açıklaması", en: "Earnings Release" },
    //       href: { tr: "/static/docs/financials/2024/q4/earnings-release-tr.pdf", en: "/static/docs/financials/2024/q4/earnings-release-en.pdf" },
    //     },
    //     {
    //       name: { tr: "Finansal Tablolar", en: "Financial Statements" },
    //       href: { tr: "/static/docs/financials/2024/q4/financial-statements-tr.pdf", en: "/static/docs/financials/2024/q4/financial-statements-en.pdf" },
    //     },
    //   ],
    //   Q3: [
    //     {
    //       name: { tr: "Yatırımcı Sunumu (Q3 2024)", en: "Investor Presentation (Q3 2024)" },
    //       href: { tr: "/static/docs/financials/2024/q3/investor-presentation-tr.pdf", en: "/static/docs/financials/2024/q3/investor-presentation-en.pdf" },
    //     },
    //   ],
    // },
  };

  const QLabel = (q) => {
    const map = { Q1: { tr: "1Ç", en: "Q1" }, Q2: { tr: "2Ç", en: "Q2" }, Q3: { tr: "3Ç", en: "Q3" }, Q4: { tr: "4Ç", en: "Q4" } };
    return map[q]?.[L] || q;
  };

  const sortedYears = Object.keys(results).map(Number).sort((a, b) => b - a);
  const quarterOrder = ["Q4", "Q3", "Q2", "Q1"];

  return (
    <div>
      <Meta title={t("financial-results")} description={t("financial-results")} lang={lang} />
      <Navbar />

      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("financial-results")}
              </h1>
            </div>
          </div>
        </div>

        <div className="po-container">
          <InvestorSidebar />

          <main className="pol-content">
            <section className="pol-card">
              <ul className="pol-list">
                {sortedYears.map((year, i) => (
                  <li key={year} className="fr-year-block">
                    {/* yılı açık başlatmak için open ekleyebilirsin */}
                    <details className="fr-year-details" {...(i === 0 ? { open: true } : {})}>
                      <summary className="fr-year fr-summary">{year}</summary>

                      {quarterOrder
                        .filter((q) => results[year]?.[q]?.length)
                        .map((q, qi) => (
                          <details key={q} className="fr-quarter-details" {...(i === 0 && qi === 0 ? { open: true } : {})}>
                            <summary className="fr-quarter fr-summary">{QLabel(q)}</summary>

                            {results[year][q].map((item, idx) => (
                              <div key={idx} className="pol-row">
                                <span className="pol-title">{item.name[L] || item.name.en}</span>
                                <a
                                  href={item.href[L] || item.href.en}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="pol-dl"
                                  aria-label={(t("download") || "İndir") + ": " + (item.name[L] || item.name.en)}
                                >
                                  <LuDownload size={18} />
                                </a>
                              </div>
                            ))}
                          </details>
                        ))}
                    </details>
                  </li>
                ))}
              </ul>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default FinancialResults;
